require("slick-carousel/slick/slick");
require("slick-carousel/slick/slick.css");

$('.slick-slideshow').slick({
    dots: false,
    infinite: false,
    speed: 300,
    fade: true,
    cssEase: 'linear'
})